import { useFetchAvailableLocations } from 'api/locations/hooks';
import { Form } from 'components';
import VanityUrlAvailabilityInput from 'components/Form/VanityUrlAvailabilityInput';
import { MediaUpload } from 'components/Form/inputs/MediaUpload/MediaUpload';
import validationSchemas from 'containers/forms/schemas';
import React, { useEffect, useMemo } from 'react';
import { Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const FormObserver = ({ values, dirty, setIsFormDirty, setFormValues }) => {
  useEffect(() => {
    setFormValues(values);
    setIsFormDirty(dirty);
  }, [values, dirty, setIsFormDirty, setFormValues]);
  return null;
};

const EditLocationGroupForm = ({
  initialValues,
  setIsFormDirty,
  setFormValues,
  setVanityAvailability,
}) => {
  const { t } = useTranslation('ownerPortal', { keyPrefix: 'locationGroups' });
  const { data: availableLocations = [] } = useFetchAvailableLocations();
  const validationSchema = useMemo(() => validationSchemas.location_group_create, []);

  return (
    <Form
      style={{ width: '100%' }}
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
      renderDefaultButtons={false}
    >
      {({ values, dirty }) => (
        <>
          <FormObserver
            values={values}
            dirty={dirty}
            setIsFormDirty={setIsFormDirty}
            setFormValues={setFormValues}
          />
          <Row sm={12} lg={12}>
            <Form.GroupHorizontal label={t('createModal.nameLabel')} required>
              <Form.Input name="name" placeholder={t('createModal.namePlaceholder')} />
            </Form.GroupHorizontal>
          </Row>

          <Row sm={12} lg={12}>
            <Form.GroupHorizontal label={t('createModal.vanityUrlLabel')} required>
              <VanityUrlAvailabilityInput
                name="vanityUrl"
                placeholder={t('createModal.vanityUrlPlaceholder')}
                prepend="https://ramblas.io/location-groups/"
                required
                onAvailabilityChange={setVanityAvailability}
              />
            </Form.GroupHorizontal>
          </Row>

          <Row sm={12} lg={12}>
            <Form.GroupHorizontal label={t('createModal.logoLabel')}>
              <MediaUpload
                accept={{
                  'image/png': ['.png'],
                  'image/jpeg': ['.jpg', '.jpeg'],
                }}
                name="logoId"
                imageField="logo"
                maxFiles={1}
                withThumbnails
                withCrop
              />
            </Form.GroupHorizontal>
          </Row>

          <Row sm={12} lg={12}>
            <Form.GroupHorizontal label={t('createModal.coverImageLabel')}>
              <MediaUpload
                accept={{
                  'image/png': ['.png'],
                  'image/jpeg': ['.jpg', '.jpeg'],
                }}
                name="coverImageId"
                imageField="coverImage"
                maxFiles={1}
                withThumbnails
                withCrop
                aspectRatio={16 / 9}
              />
            </Form.GroupHorizontal>
          </Row>
          <Row sm={12} lg={12}>
            <Form.GroupHorizontal label={t('createModal.locationsLabel')}>
              <Form.MultiSelect
                isMulti
                options={availableLocations.map((location) => ({
                  value: location.uid,
                  label: location.name,
                }))}
                name="locations"
                placeholder={t('createModal.locationsPlaceholder')}
              />
            </Form.GroupHorizontal>
          </Row>
        </>
      )}
    </Form>
  );
};
export default EditLocationGroupForm;
